import type { TokenProvider } from './auth';

type AuthTokenPair = {
  accessToken: string;
  refreshToken: string;
};

type TokenStoreSlice = {
  tokens?: {
    accessToken?: string;
    refreshToken?: string;
  };
  setTokens: (tokens: AuthTokenPair | undefined) => void;
};

/**
 * Build a TokenProvider from a Zustand-like store getState() accessor.
 * Callers supply product-specific logout / degrade callbacks.
 */
export function createStoreTokenProvider(
  getStore: () => TokenStoreSlice,
  options?: {
    onAuthInvalidated?: () => void | Promise<void>;
    onSessionDegraded?: () => void | Promise<void>;
    resyncTokens?: () => void;
  },
): TokenProvider {
  return {
    getAccessToken: () => getStore().tokens?.accessToken,
    getRefreshToken: () => getStore().tokens?.refreshToken,
    setTokens: (tokens: AuthTokenPair) => {
      getStore().setTokens(tokens);
    },
    onAuthInvalidated: options?.onAuthInvalidated,
    onSessionDegraded: options?.onSessionDegraded,
    resyncTokens: options?.resyncTokens,
  };
}
